// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

* {
    box-sizing: border-box;
}

body {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    margin: 0;
    padding: 0;
    background: var(--page-background);
    color: var(--page-foreground);
}

a {
    color: var(--link-color);
}

.desktop_main_hUZb1 section {
    max-width: 900px;
    margin: auto;
    margin-bottom: 30px;
}

.desktop_header-container_dZgrU {
    color: white;
    background-color: var(--looks-secondary);
    padding: 20px 0;
    text-align: center;
    margin-bottom: 30px;
}

.desktop_header-text_h13My {

}

.desktop_download-list_RHDTd {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.desktop_screenshot_wSRbR {
    filter: drop-shadow(0 0 1rem var(--ui-black-transparent));
    border-radius: 0.5rem;
    background-color: var(--page-background);
    width: 100%;
}

.desktop_download-button_pubuD {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    padding: 0.75rem 1rem;
    background: var(--looks-secondary);
    color: white;
    border: 1px solid var(--looks-secondary);
    font-weight: 600;
    font-size: 0.85rem;
}
`, "",{"version":3,"sources":["webpack://./src/playground/desktop/desktop.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,sBAAsB;AAC1B;;AAEA;IACI,2DAA2D;IAC3D,SAAS;IACT,UAAU;IACV,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,wCAAwC;IACxC,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yDAAyD;IACzD,qBAAqB;IACrB,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,2DAA2D;IAC3D,qBAAqB;IACrB,kCAAkC;IAClC,YAAY;IACZ,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n* {\n    box-sizing: border-box;\n}\n\nbody {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    margin: 0;\n    padding: 0;\n    background: var(--page-background);\n    color: var(--page-foreground);\n}\n\na {\n    color: var(--link-color);\n}\n\n.main section {\n    max-width: 900px;\n    margin: auto;\n    margin-bottom: 30px;\n}\n\n.header-container {\n    color: white;\n    background-color: var(--looks-secondary);\n    padding: 20px 0;\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.header-text {\n\n}\n\n.download-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n.screenshot {\n    filter: drop-shadow(0 0 1rem var(--ui-black-transparent));\n    border-radius: 0.5rem;\n    background-color: var(--page-background);\n    width: 100%;\n}\n\n.download-button {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    padding: 0.75rem 1rem;\n    background: var(--looks-secondary);\n    color: white;\n    border: 1px solid var(--looks-secondary);\n    font-weight: 600;\n    font-size: 0.85rem;\n}\n"],"sourceRoot":""}]);
// Exports
export var main = `desktop_main_hUZb1`;
var _1 = `desktop_header-container_dZgrU`;
export { _1 as "header-container" };
export var headerContainer = `desktop_header-container_dZgrU`;
var _2 = `desktop_header-text_h13My`;
export { _2 as "header-text" };
export var headerText = `desktop_header-text_h13My`;
var _3 = `desktop_download-list_RHDTd`;
export { _3 as "download-list" };
export var downloadList = `desktop_download-list_RHDTd`;
export var screenshot = `desktop_screenshot_wSRbR`;
var _4 = `desktop_download-button_pubuD`;
export { _4 as "download-button" };
export var downloadButton = `desktop_download-button_pubuD`;
export default ___CSS_LOADER_EXPORT___;
